/**
 * A simple Help page that
 *
 * - Figures out the correct Support URI based on the user's email: this takes
 *   in to account the user's locale and whether they're One Of Us ✊
 *
 * - Attempts to open a new window with this URI.
 *
 * - Shows a message with a link to the Support URI in case the user's browser
 *   doesn't allow for such jumpscares...
 *
 * TODO: I18n this ASAP.
 */

import { useEffect } from "react";
import {
  BigCenterMessage,
  segment,
  useAppName,
  useUser,
  useUserLocale,
} from "@granular/fabric3-core";
import type { SupportedLocale } from "@granular/fabric3-definitions";
import { useIntl } from "react-intl";

const SUPPORT_DOMAINS = [
  "corteva.com",
  "plantpioneer.com",
  "pioneer.com",
] as const;

// TODO: This is where you'd write a test
export const makeSupportURI = (
  locale: SupportedLocale,
  isInternalUser: boolean,
) =>
  `https://support.insights.granular.ag/hc/${locale.toLocaleLowerCase()}${isInternalUser ? "/signin" : ""}`;

const Help = () => {
  const user = useUser();
  const locale = useUserLocale();
  const currentApp = useAppName();
  const intl = useIntl();

  const emailDomain = user?.data?.email
    ? user.data.email.split("@")[1]!.toLowerCase()
    : "";
  const isInternalUser = Boolean(SUPPORT_DOMAINS.includes(emailDomain));
  const supportURI = makeSupportURI(locale, isInternalUser);

  useEffect(() => {
    window.open(supportURI);

    try {
      void segment.track("navigate to Help on left nav", { currentApp });
    } catch (error) {
      console.warn(`Failed to track event ${JSON.stringify(error)}`);
    }
  }, [supportURI, currentApp]);

  return (
    <BigCenterMessage>
      <p className="pt-4">
        {intl.formatMessage(
          { id: "help-link-landing" },
          {
            br: <br />,
            a: (text) => (
              <a
                className="fw-bold"
                href={supportURI}
                target="_blank"
                rel="noreferrer"
              >
                {text}
              </a>
            ),
          },
        )}
      </p>
    </BigCenterMessage>
  );
};

export default Help;
